import React, { Component } from 'react';
import {Row, Col} from 'react-bootstrap';
import '../styles/components/jobdetail.css';
import c_logo from '../images/c_logo.png';
import Header from './Header';
import Footer from './Footer';
import {connect} from 'react-redux';
import {NotificationContainer} from 'react-notifications';
import {ShowNotification} from './HandleNotifications';
import Loader from '../components/loader';
import database from '../firebase/firebase';
import { startApplyVacancy } from '../actions/_student_actions';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import CompanyModal from './companyModal';

class JobDetail extends Component {

    state = {
        jobID: '',
        jobSalary: '',
        jobTitle: '',
        Status: '',
        locationName: '',
        data: '',
        companyAbout: '',
        companyName: '',
        contract: '',
        postedFrom: '',
        seniority:'',
        vacancyOwner:'',
        loader: false,
        img:'',
        showModal: false,
        renderModal: false
    }
    
    componentDidMount(){
        window.scrollTo(0,0)
        if(this.props.match.params.id === undefined){
            this.props.history.goBack();
        }else {
            this.props.vacancies.map((job) => {
                if (job.jobID === this.props.match.params.id) {
                    this.setState({
                    jobID: job.jobID,
                    jobSalary: job.jobSalary,
                    jobTitle: job.jobTitle,
                    Status: job.Status,
                    locationName: job.locationName,
                    data: job.data,
                    companyAbout: job.companyAbout,
                    companyName: job.companyName,
                    contract: job.connect,
                    postedFrom: job.postedFrom,
                    seniority:job.seniority,
                    vacancyOwner: job.vacancyOwner,
                    img: job.img,
                    renderModal: true
                })
                }
            })
        }
    }

    confirmApply = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui'>
                  <p className="job-title">Confirmar</p>
                  <p className="text">¿Estas segur@ que deseas postularte a esta vacante?</p>
                  <button className="confirm-button-no" onClick={onClose}>No</button>
                  <button className="confirm-button-yes"
                    onClick={() => {
                      this.handleSubmit();
                      onClose();
                    }}
                  >
                    Sí
                  </button>
                </div>
              );
            }
          });
    }

    handleSubmit = () => {
        if(!!this.props.id){
            if(this.props.student.profile.existCv){
                this.setState({loader: true})
                database.collection(`companies/${this.state.vacancyOwner}/jobs/${this.state.jobID}/applicants/`)
                .doc(this.props.id).get()
                .then(s => {
                    if(s.data()){
                        setTimeout(() => {
                            this.setState({loader: false})
                            ShowNotification('warning', 'Ya te has postulado para esta vacante', 'En curso ... ');
                        }, 1200);
                    }else{
                        this.props.apply(this.state).then(()=>{
                            setTimeout(() => {
                                this.setState({loader: false})
                                ShowNotification('success', 'Tu información fue enviada correctamente', '¡Todo listo!');
                            }, 1200);
                        })
                    } 
                }).catch(e => {
                    console.log(e)
                })
            }else{
                ShowNotification('warning', 'Para aplicar, debes completar tu perfil', 'Información incompleta');
            }
        }else{
            ShowNotification('warning', 'Para poder postularte debes de crear una cuenta e iniciar sesión', 'Debes iniciar sesión');
        }
    }

    formatDate = (date) => {
        var event = new Date(date);
        var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        var formattedDate = event.toLocaleDateString('es-ES', options);
        return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    }

    ToggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal
        }));
    }

    render(){
        return(
            <div>
                {this.state.loader ? 
                    <div className="loader"> <Loader text={"Estamos enviando tu información"} active={this.state.loader}/> </div>
                :
                <div className="container">
                    <Row><Header {...this.props}/></Row>
                        <Row>
                            <Col className="no-float mx-auto" xs={11} sm={8} md={8} lg={8} xl={8}>
                                <div className="links">
                                    <p onClick={() => this.props.history.goBack()} className="link">Regresar a todos los trabajos</p>
                                </div>
                                <div className="resume-area">
                                    <p className="date">{this.formatDate(this.state.postedFrom)}</p>
                                    <p className="job-title">{this.state.jobTitle}</p>
                                    {this.state.origin  ? <p className="category">Empresa Top</p> : null}
                                    <p className="text">Descripción de la vacante</p>
                                    <ReactQuill
                                        className="description"
                                        value={this.state.data}
                                        readOnly={true}
                                        theme={"bubble"}
                                    />
                                    <div className="subscribe-social">
                                        <button className="posit" onClick={this.confirmApply}>Postutar</button>
                                        <div className="social-links">
                                            <p className="social-link">Facebook </p>
                                            <p className="social-link">|</p>
                                            <p className="social-link">Twitter</p>
                                            <p className="social-link">|</p>
                                            <p className="social-link"> Linkedin</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-area">
                                    <div className="c-card">
                                        {this.state.img === "" ? null : <img className="c-logo mx-auto" src={this.state.img} alt="c-logo"/>}
                                        <p className="c-name">{this.state.companyName}</p> 
                                        <p className="c-city">{this.state.locationName}</p>
                                        <button className="posit-company db-block mx-auto" 
                                        onClick={() => this.setState({showModal : true}) }>Ver más de la empresa</button>
                                        <button className="posit db-block mx-auto" onClick={this.confirmApply}>Postular</button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    <Row><Footer /></Row>
                    <NotificationContainer />
                    {this.state.renderModal ? 
                    <CompanyModal 
                        id={this.state.vacancyOwner} 
                        open={this.state.showModal} 
                        close={this.ToggleModal} />
                    : null}
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    id: state.auth.uid,
    vacancies: state.vacancies,
    student: state.student
})

const mapDispatchToProps = (dispatch) => ({
    apply: (jobData) => dispatch(startApplyVacancy(jobData))
});

export default connect(mapStateToProps, mapDispatchToProps)(JobDetail);